export default __webpack_public_path__ + "static/media/mariano.29e8c9c2.png";